import React from 'react';
import styles from './MultipleMetricCard.module.scss';

interface MultipleMetricCardProps {
  backgroundColor: string;
  titleColor: string;
  metricsColor: string;
  labelsColor: string;
  title: string;
  label1: string;
  metric1: string;
  label2: string;
  metric2: string;
  label3: string;
  metric3: string;
}

const MultipleMetricCard: React.FC<MultipleMetricCardProps> = ({
  backgroundColor,
  titleColor,
  metricsColor,
  labelsColor,
  title,
  label1,
  metric1,
  label2,
  metric2,
  label3,
  metric3,
}) => {
  return (
    <div className={styles.card} style={{ backgroundColor }}>
      <h2 className={styles.title} style={{ color: titleColor }}>
        {title}
      </h2>
      <div className={styles.metrics}>
        <div className={styles.metric}>
          <span className={styles.label} style={{ color: labelsColor }}>
            {label1}
          </span>
          <span className={styles.value} style={{ color: metricsColor }}>
            {metric1}
          </span>
        </div>
        <div className={styles.metric}>
          <span className={styles.label} style={{ color: labelsColor }}>
            {label2}
          </span>
          <span className={styles.value} style={{ color: metricsColor }}>
            {metric2}
          </span>
        </div>
        <div className={styles.metric}>
          <span className={styles.label} style={{ color: labelsColor }}>
            {label3}
          </span>
          <span className={styles.value} style={{ color: metricsColor }}>
            {metric3}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MultipleMetricCard;
